import { useCallback, useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { Icon } from '../../Icon';
import {
  StyledInputNumberController,
  StyledInputNumberControllers,
} from './InputNumberControllers.style';

export const InputNumberControllers = ({
  inputRef,
  disabled,
}: {
  inputRef: React.RefObject<HTMLInputElement>;
  disabled?: boolean;
}) => {
  const theme = useTheme();
  const [isControllersVisible, setIsControllersVisible] = useState(false);

  const onControllerClick = (modifier: 'increase' | 'decrease') => {
    const input = inputRef?.current as HTMLInputElement;

    if (!input) return;

    if (modifier === 'increase') {
      input.stepUp();
    } else {
      input.stepDown();
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const handleMouseEnter = useCallback(
    () => setIsControllersVisible(true),
    [setIsControllersVisible]
  );
  const handleMouseLeave = useCallback(
    () => setIsControllersVisible(false),
    [setIsControllersVisible]
  );

  useEffect(() => {
    const input = inputRef.current;
    const inputWrapper = input?.parentNode;

    if (inputWrapper) {
      inputWrapper.addEventListener('mouseenter', handleMouseEnter);
      inputWrapper.addEventListener('mouseleave', handleMouseLeave);
    }

    return () => {
      if (inputWrapper) {
        inputWrapper.removeEventListener('mouseenter', handleMouseEnter);
        inputWrapper.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [handleMouseEnter, handleMouseLeave, inputRef]);

  return (
    <StyledInputNumberControllers visible={isControllersVisible}>
      <StyledInputNumberController
        type="button"
        disabled={disabled}
        onClick={() => onControllerClick('increase')}
      >
        <Icon name="chevron---up" size="XSmall" color={theme.Color.Neutrals.Dark} />
      </StyledInputNumberController>

      <StyledInputNumberController
        type="button"
        disabled={disabled}
        onClick={() => onControllerClick('decrease')}
      >
        <Icon name="chevron---down" size="XSmall" color={theme.Color.Neutrals.Dark} />
      </StyledInputNumberController>
    </StyledInputNumberControllers>
  );
};
